import { render, staticRenderFns } from "./BOpenDataUpdated.vue?vue&type=template&id=89c28f0a&scoped=true"
import script from "./BOpenDataUpdated.vue?vue&type=script&lang=js"
export * from "./BOpenDataUpdated.vue?vue&type=script&lang=js"
import style0 from "./BOpenDataUpdated.vue?vue&type=style&index=0&id=89c28f0a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c28f0a",
  null
  
)

export default component.exports